

    import Template from 'ln/template/TemplateManager';
    Template.add({ui: {"tooltip":"<div class=\"tooltip-container\"><div js=\"content\" class=\"content padding-box -v-small -h\"></div></div>","tooltip-hover-content":"<div class=\"text-style -nowrap\">[[= opt.content ]]</div>"}} );

